'use server';

/**
 * «Повторить» on a v2 layer that ended partial / failed: ONLY what did not
 * come (pages / cover, blocks + the file) is made again — one more attempt,
 * an add-on order with its own hold (OrderExecutor.retryLayer).
 */
import { SessionService } from '@/contexts/authentication';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';
import type { ActionResult } from '@/shared/types/actions';

export async function retryOrderLayer(layerId: string): Promise<ActionResult<{ credits: number }>> {
  try {
    const familyId = await SessionService.getFamilyId();
    if (!familyId) return { success: false, error: 'Not authenticated' };
    const { getOrderExecutor } = await import('../executor/server');
    const r = await getOrderExecutor().retryLayer(layerId, familyId);
    if (!r.ok) return { success: false, error: r.code === 'INSUFFICIENT_ALLOWANCE' ? 'insufficient_allowance' : r.error ?? r.code, code: r.code };
    return { success: true, data: { credits: r.credits } };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('retryOrderLayer', e) };
  }
}
